import { EmptyState, NoDataIcon } from '@lmc/ui-kit'
import styled from 'styled-components'
import { getNominative } from '../../../../common/utils'
import ZoneResidentRow from './ZoneResidentRow'

interface ZoneResidentsListProps {
  onEditResident: () => void
  residents: []
  preferredPeopleNominative: string
}

export default function ZoneResidentsList({
  onEditResident,
  residents,
  preferredPeopleNominative
}: ZoneResidentsListProps) {
  if (!residents.length)
    return (
      <EmptyState
        icon={<NoDataIcon />}
        title={`No ${getNominative(
          preferredPeopleNominative,
          'residents'
        )} assigned to this zone`}
      />
    )
  return (
    <List>
      {residents.map((resident: any, index: number) => {
        const isLast = residents?.length === index + 1

        return (
          <ZoneResidentRow
            key={resident.id}
            onEdit={onEditResident}
            resident={resident}
            isLast={isLast}
          />
        )
      })}
    </List>
  )
}

export const List = styled.ul`
  padding-left: 0;
  list-style: none;
  margin-top: 24;
  margin-bottom: 24;
  border-radius: 15px;
  overflow-y: auto;
`
